import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';

import type { InvitePeopleDialogProps } from './main';

const InvitePeopleDialogSuspense = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_invite-people-dialog" */ './main'
		),
);

const LazyAddPeopleDialogNext = (props: InvitePeopleDialogProps): React.ReactElement => (
	<Suspense fallback={null}>
		<InvitePeopleDialogSuspense {...props} />
	</Suspense>
);

const LazyAddPeopleDialogLegacy: ComponentType<InvitePeopleDialogProps> &
	Loadable.LoadableComponent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_invite-people-dialog" */ './main'
		),
	loading: () => null,
});
LazyAddPeopleDialogLegacy.displayName = 'lazy(AddPeopleDialog)';

const LazyAddPeopleDialog = (props: InvitePeopleDialogProps): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? (
		<LazyAddPeopleDialogNext {...props} />
	) : (
		<LazyAddPeopleDialogLegacy {...props} />
	);

export default LazyAddPeopleDialog;
